import {useNavigation} from '@react-navigation/native';
import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {AUTHENTICATED_ROUTES} from '../../../navigation/constants';
import {useIsLandscape} from '../../../utils';
import {Page} from '../../components';
import ConfigurePackageModal from '../Home/components/ConfigurePackageModal';
import ChangeGradeModal from '../Home/components/ChangeGradeModal';
import SubscriptionLandscapeModalController from './SubscriptionLandscapeModalController';
import AlertMessageModal from '../Home/components/AlertMessageModal';
import PackageList from '../Home/components/CardsList/PackageList';
import {
  basicPackageImage,
  individualSubjectPackageImage,
  proPackageImage,
} from '../../../assets/images';

const Subscription = () => {
  const navigation = useNavigation();
  const isLandscape = useIsLandscape();
  const [checkGrade, setCheckGrade] = useState();
  const [packageToBuy, setPackageToBuy] = useState();
  const [landscapeParams, setLandscapeParams] = useState();
  const [showAlertMessage, setShowAlertMessage] = useState(false);
  const kids = useSelector((state) => state.general.kids);
  const selectedStudent = kids?.[0];

  const [selectedPackage, setSelectedPackage] = useState();

  const individualPlanData = {
    title: 'Star Individual Subjects',
    heading: {
      titleText: 'Star Individual',
      subTitleText: 'Subjects',
    },
    subtitle: 'INDIVIDUAL SUBJECTS PLAN',
    packageType: 'Individual',
    image: individualSubjectPackageImage,
    selectedStudent,
    onPress: (packageData) => {
      setSelectedPackage(packageData);
      setShowAlertMessage(true);
    },
  };

  const basicPackageData = {
    title: 'Start Basic Package',
    heading: {
      titleText: 'Star Basic',
      subTitleText: 'Package',
    },
    subtitle: 'TUTORIAL CLASSES ONLY',
    packageType: 'Package',
    image: basicPackageImage,
    selectedStudent,
    disabled: true,
    onPress: (packageData) => setCheckGrade(packageData),
  };

  const proPackageData = {
    title: 'Star Pro Package',
    heading: {
      titleText: 'Star Pro',
      subTitleText: 'Package',
    },
    subtitle: 'TUTORIAL + INTENSIVE CLASSES',
    packageType: 'Pro',
    discount:
      'Enjoy 10% discount for Star Pro Package\n(Only for Dec & Jan Subscription)',
    image: proPackageImage,
    selectedStudent,
    onPress: (packageData) => {
      setSelectedPackage(packageData);
      setShowAlertMessage(true);
    },
  };

  const purchasePackages = [];

  purchasePackages.push(proPackageData);
  purchasePackages.push(basicPackageData);
  purchasePackages.push(individualPlanData);

  return (
    <>
      <Page header={{title: 'Buy/Renew Subscription', showDrawerAction: true}}>
        <PackageList data={purchasePackages} disabled />
      </Page>
      {Boolean(checkGrade) && (
        <ChangeGradeModal
          kidId={selectedStudent?.id}
          packageData={checkGrade}
          onClose={() => setCheckGrade(undefined)}
          onNextPressed={(paramsToSet) => {
            setPackageToBuy(checkGrade);
          }}
        />
      )}
      {Boolean(packageToBuy) && (
        <ConfigurePackageModal
          kidId={selectedStudent?.id}
          packageData={packageToBuy}
          onClose={() => setPackageToBuy(undefined)}
          onNextPressed={(paramsToSet) => {
            if (isLandscape) {
              setLandscapeParams(paramsToSet);
            } else {
              navigation.navigate(
                AUTHENTICATED_ROUTES.configurePackage.path,
                paramsToSet,
              );
            }
          }}
        />
      )}
      {Boolean(landscapeParams) && (
        <SubscriptionLandscapeModalController
          params={landscapeParams}
          handleClose={() => setLandscapeParams(undefined)}
        />
      )}
      {Boolean(showAlertMessage) && (
        <AlertMessageModal
          title="GOOD NEWS!"
          description="Enjoy 10% discount for Star Pro Package"
          note="(Only for Dec & Jan Subscription)"
          okButtonText="Ok, Proceed with Star Pro Package"
          onClose={() => {
            setShowAlertMessage(false);
            setCheckGrade(selectedPackage);
          }}
          onConfirm={() => {
            setShowAlertMessage(false);
            setCheckGrade(proPackageData);
          }}
        />
      )}
    </>
  );
};

export default Subscription;
